import React from 'react'

export const Footer = () => {
    return (
        <div >
            <footer class="text-center text-white bg-dark text-white">

                <div class="container pt-2">
                    <section class="mb-4">

                        <a
                            class="btn btn-link btn-floating btn-lg  m-1"
                            href="#!"
                            role="button"
                            data-mdb-ripple-color="dark"
                        ><i class="fab fa-facebook-f"></i
                        ></a>


                        <a
                            class="btn btn-link btn-floating btn-lg  m-1"
                            href="#!"
                            role="button"
                            data-mdb-ripple-color="dark"
                        ><i class="fab fa-twitter"></i
                        ></a>

                        <a
                            class="btn btn-link btn-floating btn-lg m-1"
                            href="#!"
                            role="button"
                            data-mdb-ripple-color="dark"
                        ><i class="fab fa-google"></i
                        ></a>

                        <a
                            class="btn btn-link btn-floating btn-lg m-1"
                            href="#!"
                            role="button"
                            data-mdb-ripple-color="dark"
                        ><i class="fab fa-instagram"></i
                        ></a>

                        <a
                            class="btn btn-link btn-floating btn-lg  m-1"
                            href="#!"
                            role="button"
                            data-mdb-ripple-color="dark"
                        ><i class="fab fa-linkedin"></i
                        ></a>

                        <a
                            class="btn btn-link btn-floating btn-lg m-1"
                            href="#!"
                            role="button"
                            data-mdb-ripple-color="dark"
                        ><i class="fab fa-github"></i
                        ></a>
                    </section>
                </div>

                <div class="text-center ps-5 pb-3">
                    © 2020 Copyright:
                    <a class="ps-3" href="https://mdbootstrap.com/">MDBootstrap.com</a>
                </div>

            </footer>
        </div>
    )
}
